@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.grid {
  display: flex;
  width: 100%;
}

.loadingContainer {
  width: 100%;
  height: 400px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.timeLabels {
  display: flex;
  flex-direction: column;
  padding-top: 30px; // Space for day labels
  gap: 1px;
}

.timeLabel {
  height: 16px;
  font-size: 10px;
  color: var(--dark-40);
  text-align: right;
  padding-right: 12px;
  width: 50px;
}

.heatmapGrid {
  flex: 1;
  display: flex;
  background: white;
  gap: 1px;
}

.dayColumn {
  flex: 1;
  background: white;

  &:last-child {
    border-right: none;
  }
}

.dayLabel {
  @include sm-sohne;
  height: 30px;
  line-height: 30px;
  color: var(--dark-80);
  text-align: center;
}

.cells {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: white;
}

.cell {
  height: 16px;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
}

.tooltip {
  background: white;
  padding: 6px 12px;
  border-radius: 10px;
  @include dropdown-shadow;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.toolTipSection {
  display: flex;
}
